import { useMutation, useQuery } from "react-query";
import { MUTATIONS, QUERIES } from "../../../../../../_api/queries";
import { useMemo } from "react";

const additionalQueryProps = {
    refetchOnWindowFocus: false,
    staleTime: 2 * 60 * 1000,        // Data stays fresh for 2 minutes
    cacheTime: 5 * 60 * 1000,       // Cache data for 5 minutes before garbage collection
}
export function useSso(companyId, propertyId)
{
    const { data: accessRolesList, refetch: refetchAccessRolesList, isLoading: isLevelsLoading } = useQuery({
        ...QUERIES.sso.ACCESS_LEVELS(propertyId),
        enabled: !!propertyId,
        select: (data) => (data?.success ?  data.userRoles : []),
        ...additionalQueryProps
    });

    const { data: claimList, refetch: refetchClaims, isLoading: isClaimsLoading} = useQuery({
        ...QUERIES.sso.SSO_CLAIMS(companyId),
        enabled: !!companyId, 
        ...additionalQueryProps
    });

    const { data: claimAccessData, refetch: refetchClaimAccessData, isLoading: isAccessDataLoading } = useQuery({
        ...QUERIES.sso.CLAIM_ACCESS(companyId),
        enabled: !!companyId,
        ...additionalQueryProps
    });

    // add claim access
    const { mutateAsync: mutateAddClaimAccess, reset : resetAddClaimAccess, isLoading: isAddAccessLoading } = useMutation(
        MUTATIONS.sso.ADD_CLAIM_ACCESS(refetchClaimAccessData)
    );
    // update claim access
    const { mutateAsync: mutateUpdateClaimAccess, reset : resetUpdateClaimAccess, isLoading: isUpdateAccessLoading } = useMutation(
        MUTATIONS.sso.UPDATE_CLAIM_ACCESS(refetchClaimAccessData)
    );
    // save claim products
    const { mutateAsync: mutateSaveClaimProducts, reset : resetSaveClaimProducts, isLoading: isSaveProductsLoading } = useMutation(
        MUTATIONS.sso.SAVE_CLAIM_PRODUCTS(refetchClaimAccessData)
    );

    const refetchData = () => {
        refetchClaims();
        refetchClaimAccessData();
    }

    const claimsGroupedByPropertyId = useMemo(() => claimAccessData?.reduce((acc, client) => {
        const roles = client?.accessRoles;
        if (roles) {
            roles.forEach((role) => {
                const { propertyId, accessRoleId } = role;
                const newObject = {
                    ssoClaimId: client.ssoClaimId,
                    claimName: client.claimName,
                    propertyId: propertyId,
                    accessRoleId: accessRoleId,
                    products: client.products,
                };
                // If the propertyId key doesn't exist, create an empty array
                if (!acc[propertyId]) {
                    acc[propertyId] = [];
                }
                acc[propertyId].push(newObject);
            });
        }
        return acc;
    }, {}), [claimAccessData]);

    const isAccessLoading= (isAddAccessLoading || isUpdateAccessLoading || isSaveProductsLoading);
    const isFetchComplete = !(isClaimsLoading || isLevelsLoading || isAccessDataLoading || isAccessLoading);
    return {
        isFetchComplete,
        accessRolesList,
        isLevelsLoading,
        refetchAccessRolesList,

        // claims
        claimList,
        isClaimsLoading,
        // add access
        mutateAddClaimAccess,
        resetAddClaimAccess,
        isAccessLoading,
        // delete access
        mutateUpdateClaimAccess,
        resetUpdateClaimAccess,
        // save claim products
        mutateSaveClaimProducts,
        resetSaveClaimProducts,
        
        claimAccessData,
        claimsGroupedByPropertyId,
        refetchData
    };

}
